"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var react_1 = require("redux-persist/integration/react");
var pages_1 = require("./pages/");
require("./pages/_shared/styles/main.scss");
var react_redux_1 = require("react-redux");
var store_1 = require("./store");
var constants_1 = require("./constants");
var react_datepicker_1 = require("react-datepicker");
var locale_1 = require("date-fns/locale");
var ErrorBoundary_1 = require("./ErrorBoundary");
(0, react_datepicker_1.registerLocale)(constants_1.DEFAULT_LANGUAGE, locale_1.nl);
var loading = function () { return (React.createElement("div", { className: "preloading" },
    React.createElement("i", { className: "material-icons" }, "pin_drop"),
    "Welkom")); };
ReactDOM.render((React.createElement(react_redux_1.Provider, { store: store_1.store },
    React.createElement(react_1.PersistGate, { loading: loading, persistor: store_1.persistor },
        React.createElement(ErrorBoundary_1.default, null,
            React.createElement(pages_1.App, null))))), document.getElementById('application'));
